__turbopack_context__.v({
  "caption": "WJKgdq_caption",
  "figure": "WJKgdq_figure",
  "image": "WJKgdq_image",
  "imageWrapper": "WJKgdq_imageWrapper",
  "placeholder": "WJKgdq_placeholder",
});
